import { useMemo } from "react";
import { Business } from "src/types";
import { FEATURE_FLAG } from "src/util/common-constants";

const useQRHuEnabled = (business: Business | null): boolean => {
  const qrHUConnectEnabled = useMemo(() => {
    const featureFlag = business?.featureFlag?.find(
      (flag) => flag.flagName === FEATURE_FLAG.QR_HU_CONNECT_ENABLED
    );

    return featureFlag?.flagStatus ?? false;
  }, [business]);

  return qrHUConnectEnabled;
};

export default useQRHuEnabled;
